export default {
	comments: {
		confirm_delete_comment: 'Möchten Sie den Kommentar wirklich löschen?',
		// Gemeinsame Sektion „Kommentare / E-Mails" (Meldungen + Handwerkeraufträge)
		composer: {
			modeComment: '@:common.comment',
			modeMail: 'Mailversand',
			open: 'Kommentar oder E-Mail schreiben',
			to: 'An',
			cc: 'CC',
			bcc: 'BCC',
			subject: '@:common.subject',
			body: 'Nachricht',
			template: 'Vorlage',
			templateHint:
				'Wählen Sie eine Vorlage, um Betreff und Text automatisch zu befüllen. Beide Felder bleiben danach frei bearbeitbar.',
			noEmail: 'Keine E-Mail-Adresse hinterlegt',
			freeEmailHint:
				'Weitere E-Mail-Adresse eingeben und mit Enter bestätigen',
			invalidEmail: '„{value}" ist keine gültige E-Mail-Adresse.',
			recipientRequired:
				'Bitte wählen Sie mindestens einen Empfänger im Feld „An" aus.',
			subjectRequired: 'Bitte geben Sie einen Betreff ein.',
			bodyRequired: 'Bitte geben Sie eine Nachricht ein.',
			missingPlaceholders:
				'Für folgende Felder liegen keine Werte vor: {fields}',
			confirmOverwriteTemplate:
				'Beim Wechsel der Vorlage gehen Ihre Änderungen an Betreff und Text verloren. Möchten Sie fortfahren?',
			previewFailed: 'Die Vorschau konnte nicht geladen werden.',
			sendFailed: 'Die E-Mail konnte nicht versendet werden.',
			publicLabel: 'öffentlich',
			internalLabel: 'intern',
			emailConflict:
				'Die interne Markierung ist mit dem E-Mail-Versand nicht möglich',
			markAsInternal: 'Kommentar als intern markieren',
			internalInfo: 'Der Kommentar wird nur der Hausverwaltung angezeigt',
			attachments: {
				title: 'Anhänge',
				none: 'Keine Anhänge',
				show: 'Anhänge hinzufügen',
				hide: 'Anhänge ausblenden',
				upload: 'Dateien auswählen',
				existing: 'Zugeordnete Dokumente anhängen',
				noDocuments: 'Keine zugeordneten Dokumente vorhanden.',
				totalSize: 'Anhänge gesamt: {size}',
			},
		},
	},
}
